import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import OrganisationDetails from "../Create/OrganisationDetails";
import Profile from "../Create/Profile";
import Contact from "../Create/Contact";
import PreContract from "../Create/PreContract";
import Contract from "../Create/Contract";
import Activity from "../Create/Activity";
import General from "../Create/General";
import OrganisationBusinessDevelopment from "../Create/OrganisationBusinessDevelopment";
import { ValidateEmail } from "../../../../../Common/Utils/common_utils";
import { useParams } from "react-router-dom";
import { UploadFunction } from "../Create/OrganisationDetails";
import { useHistory } from "react-router";

import {
  UpdateOrganisationDetails,
  SetOrganisationDetailsError,
  ResetOrganisationDetails,
  UpdateOrganisationDetailsSectionId,
  SetOrganisationDetails,
} from "../Create/OrganisationDetails/OrganisationDetailsActions";
import {
  UpdateOrganisationProfile,
  UpdateOrganisationIdProfile,
  SetOrganisationProfileError,
  SetProfileSectionAndOrgIds,
  SetOrganisationProfile,
} from "../Create/Profile/OrganisationProfileActions";
import {
  UpdateOrganisationContact,
  UpdateOrganisationIdContact,
  SetOrganisationContactError,
  SetContactSectionAndOrgIds,
  SetOrganisationContact,
} from "../Create/Contact/OrganisationContactActions";
import {
  UpdateOrganisationPreContract,
  UpdateOrganisationIdPreContract,
  SetPreContractSectionAndOrgIds,
  SetOrganisationPreContract,
} from "../Create/PreContract/OrganisationPreContractActions";
import {
  UpdateOrganisationContract,
  UpdateOrganisationIdContract,
  SetOrganisationContractError,
  SetOrganisationContractSectionAndOrgIds,
  SetOrganisationContract,
} from "../Create/Contract/OrganisationContractActions";
import {
  UpdateOrganisationActivity,
  UpdateOrganisationIdActivity,
  SetOrganisationActivityError,
  SetOrganisationActivitySectionAndOrgIds,
  SetOrganisationActivity,
} from "../Create/Activity/OrganisationActivityActions";
import {
  UpdateOrganisationGeneral,
  UpdateOrganisationIdGeneral,
  SetGeneralSectionAndOrgIds,
  SetOrganisationGeneral,
} from "../Create/General/OrganisationGeneralActions";
import {
  UpdateOrganisationBusinessDev,
  UpdateOrganisationIdBusinessDev,
  SetOrganisationBusinessDevError,
  SetOrganisationBusinessDevSectionAndOrgIds,
  SetOrganisationBusinessDev,
} from "../Create/OrganisationBusinessDevelopment/OrganisationBusinessDevelopmentActions";

import { useSelector, useDispatch } from "react-redux";
import DataService from "../../../../../Service";
import Loader from "../../../../../Components/Loader";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import { SET_ORGANISATION_DROPDOWN_VALUES } from "../../../../../Redux/actions";
import { UploadFilesComponentContext } from "../../../../../Components/FormGenerator/context/UploadFilesComponentContext";
import { Dialog, DialogTitle, DialogContent, Grid } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginRight: theme.spacing(1),
    textTransform: "none",
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepperButtons: {
    position: "sticky",
    display: "flex",
    justifyContent: "space-between",
    bottom: "0px",
    backgroundColor: "white",
    padding: "10px 0px 20px 0px",
    zIndex: 1,
  },
  stepperContent: {
    position: "sticky",
    top: "186px",
    backgroundColor: "white",
    zIndex: 2,
    paddingBottom: "20px",
  },
  stepperContentCreate: {
    top: "132px",
    position: "sticky",
    backgroundColor: "white",
    zIndex: 2,
    paddingBottom: "20px",
  },
}));

// const theme = createMuiTheme({
//   overrides: {
//     MuiStepper: {
//       root: {
//         padding: "0px",
//       },
//     },
//     MuiStep: {
//       root: {
//         width: "100%",
//         border: "1px solid rgb(7, 127,131)",
//         padding: "10px",
//         margin: "2px",
//       },
//       completed: {
//         backgroundColor: "rgb(7, 127,131)",
//       },
//       active: {
//         backgroundColor: "rgb(7, 127,131)",
//       },
//     },
//     MuiStepLabel: {
//       label: {
//         color: "rgb(7, 127,131)",
//         fontWeight: "normal",
//         fontSize: "10px",
//       },
//       active: {
//         color: "white !important",
//       },
//       completed: {
//         color: "white !important",
//       },
//     },
//     MuiStepIcon: {
//       root: {
//         color: "rgb(7, 127,131)",
//       },
//       completed: {
//         color: "white !important",
//       },
//       active: {
//         color: "white !important",
//       },

//       text: {
//         fill: "black",
//       },
//     },
//     MuiButton: {
//       containedPrimary: {
//         backgroundColor: "#3b86ff",
//       },
//       containedSecondary: {
//         backgroundColor: "#EF7000",

//         '&:hover': {
//           backgroundColor: "#EF7000"
//         }

//       },
//     },
//   },
// });

export default function OrganisationLinearStepper(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  let { id } = useParams();
  const globaluserData = useSelector((state) => state.commonReducer);
  const userRole = globaluserData?.role;

  const [loading, setLoading] = useState(false);
  const [parentOrg, setParentOrganisation] = useState(false);
  let authHeaders = JSON.parse(sessionStorage.getItem("authorization_headers"));
  if (!authHeaders) {
    authHeaders = JSON.parse(globaluserData.authHeaders || {});
  }
  const [isAdmin, setIsAdmin] = useState(true);
  const [movable, setMovable] = useState();
  //
  const [open, setOpen] = useState(false);
  //
  const [someChangeDetected, setSomeChangeDetected] = useState(false);
  useEffect(() => {
    if (userRole === "employee") {
      setIsAdmin(false);
    }
  }, []);
  const [organizationImageBlob, setOrganizationImageBlob] = useState(null);

  const { fileDataState, fetchedFilesState } = useContext(
    UploadFilesComponentContext
  );

  // selected file data
  const { fileData, setFileData } = fileDataState;

  //fetched files from the server
  const { setFetchedFiles, fetchedFiles } = fetchedFilesState;

  //---------------------------------------------------------------------
  //-------------------- Organisation details files  --------------------
  let organizationPictureFiles = {
    organisation_id: "",
    file_type: "",
    file: [],
  };

  let organizationDocumentFiles = {
    organisation_id: "",
    file_type: "",
    file: [],
  };

  fileData.forEach((item) => {
    if (item.type === "picture" || item.type === "profile_picture") {
      organizationPictureFiles.file_type = item.type;
      organizationPictureFiles.file = item.files;
    } else if (item.type === "meeting_documents") {
      organizationDocumentFiles.file_type = item.type;
      organizationDocumentFiles.file = item.files;
    }
  });

  let generalDocumentationFiles = {
    organisation_id: "",
    file_type: "",
    file: [],
  };
  let accountsDocumentationFiles = {
    organisation_id: "",
    file_type: "",
    file: [],
  };

  fileData.forEach((item) => {
    if (item.type === "general_documents") {
      generalDocumentationFiles.file_type = item.type;
      generalDocumentationFiles.file = item.files;
    } else if (item.type === "accounts_documents") {
      accountsDocumentationFiles.file_type = item.type;
      accountsDocumentationFiles.file = item.files;
    }
  });

  let proposalsFiles = {
    organisation_id: "",
    file_type: "",
    file: [],
  };

  let presentationsFiles = {
    organisation_id: "",
    file_type: "",
    file: [],
  };

  let commercialFiles = {
    organisation_id: "",
    file_type: "",
    file: [],
  };

  let rfiFiles = {
    organisation_id: "",
    file_type: "",
    file: [],
  };

  fileData.forEach((item) => {
    if (item.type === "proposals") {
      proposalsFiles.file_type = item.type;
      proposalsFiles.file = item.files;
    } else if (item.type === "presentations") {
      presentationsFiles.file_type = item.type;
      presentationsFiles.file = item.files;
    } else if (item.type === "commercial") {
      commercialFiles.file_type = item.type;
      commercialFiles.file = item.files;
    } else if (item.type === "RFI") {
      rfiFiles.file_type = item.type;
      rfiFiles.file = item.files;
    }
  });

  //-------------------------------------------------------------------
  //--------------------organisation contract files--------------------
  let legalContractsFiles = {
    organisation_id: "",
    file_type: "",
    file: [],
  };
  fileData.forEach((item) => {
    if (item.type === "legal_contracts") {
      legalContractsFiles.file_type = item.type;
      legalContractsFiles.file = item.files;
    }
  });

  //---------------------------------------------------------------------
  //-------------------- Organisation Cntract files  --------------------
  let contractPictureFiles = {
    organisation_id: "",
    file_type: "",
    file: [],
  };

  fileData.forEach((item) => {
    if (item.type === "variation_agreement_documents") {
      contractPictureFiles.file_type = item.type;
      contractPictureFiles.file = item.files;
    }
  });
  //-------------------------------------------------------------------
  //--------------------organisation activity files--------------------
  let activityPictureFiles = {
    organisation_id: "",
    file_type: "",
    file: [],
  };

  fileData.forEach((item) => {
    if (item.type === "lient_action_list") {
      activityPictureFiles.file_type = item.type;
      activityPictureFiles.file = item.files;
    }
  });
  useEffect(() => {
    setLoading(true);
    if (id) {
      // fetching files
      DataService.getDirectData(
        `/organisations/listing_files?organisation_id=${id}`
      )
        .then((res) => {
          setFetchedFiles(res.organisation_documents);
        })
        .catch((err) => console.log("error"));

      DataService.getData({ organisation_id: id }, "all_organisation_dropdowns")
        .then((response) => {
          setParentOrganisation(response.parent_organisations);
          dispatch({
            type: SET_ORGANISATION_DROPDOWN_VALUES,
            payload: response,
          });
          !id && setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          dispatch(showSnackbar("error", err.errors));
        });
    } else {
      DataService.getData({}, "all_organisation_dropdowns")
        .then((response) => {
          dispatch({
            type: SET_ORGANISATION_DROPDOWN_VALUES,
            payload: response,
          });
          !id && setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          dispatch(showSnackbar("error", err.errors));
        });
      setFetchedFiles([]);
      setFileData([]);
    }

    if (id) {
      setLoading(true);
      DataService.getDirectData(`/organisations/${id}`)
        .then((response) => {
          setMovable(response.movable);
          dispatch(UpdateOrganisationDetailsSectionId(id));
          dispatch(SetOrganisationDetails(response.data));
          dispatch(
            SetContactSectionAndOrgIds({
              sectionId: response.organisation_contact_info_id,
              organisationId: id,
            })
          );
          dispatch(
            SetProfileSectionAndOrgIds({
              sectionId: response.organisation_profile_id,
              organisationId: id,
            })
          );
          dispatch(
            SetGeneralSectionAndOrgIds({
              sectionId: response.organisation_general_detail_id,
              organisationId: id,
            })
          );
          dispatch(
            SetPreContractSectionAndOrgIds({
              sectionId: response.organisation_pre_contract_id,
              organisationId: id,
            })
          );
          dispatch(
            SetOrganisationContractSectionAndOrgIds({
              sectionId: response.organisation_contract_phase_id,
              organisationId: id,
            })
          );
          dispatch(
            SetOrganisationActivitySectionAndOrgIds({
              sectionId: response.organisation_activity_field_id,
              organisationId: id,
            })
          );
          dispatch(
            SetOrganisationBusinessDevSectionAndOrgIds({
              sectionId: response.organisation_business_development_id,
              organisationId: id,
            })
          );
          response &&
            response.organisation_profile_id &&
            DataService.getDirectData(
              `/organisation_profiles/${response.organisation_profile_id}`
            )
              .then((res) => {
                dispatch(SetOrganisationProfile(res.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          response &&
            response.organisation_contact_info_id &&
            DataService.getDirectData(
              `/organisation_contact_infos/${response.organisation_contact_info_id}`
            )
              .then((res) => {
                console.log(res.data, "contactt");
                dispatch(SetOrganisationContact(res.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          response &&
            response.organisation_pre_contract_id &&
            DataService.getDirectData(
              `/organisation_pre_contracts/${response.organisation_pre_contract_id}`
            )
              .then((res) => {
                dispatch(SetOrganisationPreContract(res.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          response &&
            response.organisation_contract_phase_id &&
            DataService.getDirectData(
              `/organisation_contract_phases/${response.organisation_contract_phase_id}`
            )
              .then((res) => {
                dispatch(SetOrganisationContract(res.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          response &&
            response.organisation_activity_field_id &&
            DataService.getDirectData(
              `/organisation_activity_fields/${response.organisation_activity_field_id}`
            )
              .then((res) => {
                dispatch(SetOrganisationActivity(res.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          response &&
            response.organisation_general_detail_id &&
            DataService.getDirectData(
              `/organisation_general_details/${response.organisation_general_detail_id}`
            )
              .then((res) => {
                dispatch(SetOrganisationGeneral(res.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          response &&
            response.organisation_business_development_id &&
            DataService.getDirectData(
              `/organisation_business_developments/${response.organisation_business_development_id}`
            )
              .then((res) => {
                dispatch(SetOrganisationBusinessDev(res.data));
              })
              .catch((err) => {
                setLoading(false);
                dispatch(showSnackbar("error", err.errors));
              });

          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, []);

  function getSteps() {
    return [
      "Organization details",
      "Profile",
      "Contact",
      "Business development",
      "Scoping phase",
      "Contract",
      "Reporting and Review",
      "General",
      // "General",
      //       "Contact Area",
      // "Employee CUrrent Work Information And History",
      // "Training and Development",
      // "Coaching Capacity",
      // "Mentoring Capacity",
      // "Coaching Profile",
      // "Mentor Profile",
      // "Facilitation",
      // "Assessment",
      // "GDPR"
    ];
  }

  const OrganisationDetail = useSelector(
    (state) => state.organisationDetailsReducer
  );

  const OrgId = useSelector(
    (state) => state.organisationDetailsReducer.data.id
  );

  const OrganisationProfile = useSelector(
    (state) => state.organisationProfileReducer
  );

  const OrganisationContact = useSelector(
    (state) => state.organisationContactReducer
  );

  const OrganisationPreContract = useSelector(
    (state) => state.organisationPreContractReducer
  );

  const OrganisationContract = useSelector(
    (state) => state.organisationContractReducer
  );

  const OrganisationActivity = useSelector(
    (state) => state.organisationActivityReducer
  );

  const OrganisationGeneral = useSelector(
    (state) => state.organisationGeneralReducer
  );
  const organisationBusinessDevelopment = useSelector(
    (state) => state.organisationBusinessDevelopmentReducer
  );

  // for section first
  //----------------------------------------------------------------------
  //-------------------- Organisation detail form data --------------------
  const OrganisationDetailFormData = new FormData();

  for (const key in OrganisationDetail.data) {
    const data = OrganisationDetail.data;

    // if key of the object is an Array
    // let tempArr = data && data[key].map(option => option.value ?? option);
    // if( key === "fully_managed_service"){
    //   console.log('datatypeof :>> ',key, data[key]);

    //   OrganisationDetailFormData.append(key,JSON.stringify(data[key]));
    //  }
    //  else

    if (Array.isArray(data[key])) {
      // data[key].forEach((item) => {
      //   OrganisationDetailFormData.append(`${key}[]`, item);
      //   console.log(`${key}[]`, item);
      // });
      let tempArr = data && data[key].map((option) => option.value ?? option);
      // data[key].map((option) => langArr.push(option.id))
      // ContactAreaFormData.append(`${key}[]`, JSON.stringify(langArr) );
      // console.log('datakey, :>> ', key,data && data[key].map(option => option.value));
      if (tempArr.length === 0) {
        OrganisationDetailFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          OrganisationDetailFormData.append(`${key}[]`, option);
        });
      }
    } else {
      if (key === "client_account_management") {
        OrganisationDetailFormData.append(
          "client_account_management_id",
          data[key]
        );
      } else {
        OrganisationDetailFormData.append(key, data[key]);
      }
    }
  }

  // files
  if (!id && !OrgId) {
    organizationPictureFiles?.file.forEach((item) => {
      OrganisationDetailFormData.append("picture[]", item, item.name);
    });
    organizationDocumentFiles?.file.forEach((item) => {
      OrganisationDetailFormData.append("meeting_documents[]", item, item.name);
    });
  }

  if (organizationImageBlob) {
    OrganisationDetailFormData.append("picture[]", organizationImageBlob);
  }

  //-----------------------------------------------------------
  // for section second
  //-------------------- profile form data --------------------
  const organisationProfileFormData = new FormData();

  for (const key in OrganisationProfile.data) {
    const data = OrganisationProfile.data;

    // if key of the object is an Array
    if (Array.isArray(data[key])) {
      // data[key].forEach((item) => {
      //   OrganisationDetailFormData.append(`${key}[]`, item);
      //   console.log(`${key}[]`, item);
      // });
      let tempArr = data && data[key].map((option) => option.value ?? option);
      // data[key].map((option) => langArr.push(option.id))
      // ContactAreaFormData.append(`${key}[]`, JSON.stringify(langArr) );
      // console.log('datakey, :>> ', key,data && data[key].map(option => option.value));
      if (tempArr.length === 0) {
        organisationProfileFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          organisationProfileFormData.append(`${key}[]`, option);
        });
      }
    } else {
      organisationProfileFormData.append(key, data[key]);
    }
  }
  // files
  if (!id && !OrgId) {
    generalDocumentationFiles?.file.forEach((item) => {
      organisationProfileFormData.append(
        "general_documents[]",
        item,
        item.name
      );
    });

    generalDocumentationFiles?.file.forEach((item) => {
      organisationProfileFormData.append(
        "accounts_documents[]",
        item,
        item.name
      );
    });
  }

  //-----------------------------------------------------------
  // for section third
  //-------------------- contact form data --------------------

  // OrganisationContact.data,
  const OrganisationContactFormData = new FormData();

  for (const key in OrganisationContact.data) {
    const data = OrganisationContact.data;

    // if key of the object is an Array
    // if (Array.isArray(data[key])) {
    //   data[key].forEach((item) => {
    //     OrganisationContactFormData.append(`${key}[]`, item);
    //   });
    // }
    // if (Array.isArray(data[key])) {
    //   // data[key].forEach((item) => {
    //   //   OrganisationDetailFormData.append(`${key}[]`, item);
    //   //   console.log(`${key}[]`, item);
    //   // });
    //   let tempArr = data && data[key].map(option => option.value ?? option);
    //   // data[key].map((option) => langArr.push(option.id))
    //   // ContactAreaFormData.append(`${key}[]`, JSON.stringify(langArr) );
    //   // console.log('datakey, :>> ', key,data && data[key].map(option => option.value));
    //   if (tempArr.length === 0) {
    //     OrganisationContactFormData.append(`${key}[]`, "")
    //   } else {
    //     tempArr.map((option) => {
    //       OrganisationContactFormData.append(`${key}[]`, option)
    //     });
    //   }

    // }
    if (Array.isArray(data[key])) {
      // data[key].forEach((item) => {
      //   OrganisationDetailFormData.append(`${key}[]`, item);
      //   console.log(`${key}[]`, item);
      // });
      let tempArr = data && data[key].map((option) => option.value ?? option);
      // data[key].map((option) => langArr.push(option.id))
      // ContactAreaFormData.append(`${key}[]`, JSON.stringify(langArr) );
      // console.log('datakey, :>> ', key,data && data[key].map(option => option.value));
      if (tempArr.length === 0) {
        OrganisationContactFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          OrganisationContactFormData.append(`${key}[]`, option);
        });
      }
    } else {
      OrganisationContactFormData.append(key, data[key]);
    }
  }

  //-----------------------------------------------------------------------------
  // for section fourth
  //-------------------- organisation pre contract  form data --------------------
  const OrganisationPreContractFormData = new FormData();

  for (const key in OrganisationPreContract.data) {
    const data = OrganisationPreContract.data;

    // if key of the object is an Array
    if (Array.isArray(data[key])) {
      let tempArr = data && data[key].map((option) => option.value ?? option);

      if (tempArr.length === 0) {
        OrganisationPreContractFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          OrganisationPreContractFormData.append(`${key}[]`, option);
        });
      }
    } else {
      OrganisationPreContractFormData.append(key, data[key]);
    }
  }

  // fiels

  if (!id && !OrgId) {
    // scopingFiles?.file.forEach((item) => {
    //   OrganisationPreContractFormData.append("scopings[]", item, item.name);
    // });

    proposalsFiles?.file.forEach((item) => {
      OrganisationPreContractFormData.append("proposals[]", item, item.name);
    });

    presentationsFiles?.file.forEach((item) => {
      OrganisationPreContractFormData.append(
        "presentations[]",
        item,
        item.name
      );
    });

    commercialFiles?.file.forEach((item) => {
      OrganisationPreContractFormData.append("commercial[]", item, item.name);
    });

    rfiFiles?.file.forEach((item) => {
      OrganisationPreContractFormData.append("RFI[]", item, item.name);
    });
  }

  const OrganisationContractFormData = new FormData();
  for (const key in OrganisationContract.data) {
    const data = OrganisationContract.data;
    if (key === "fiscal_year") {
      OrganisationContractFormData.append(
        key,
        JSON.stringify(data[key] || { to_month: "", from_month: "" })
      );
    } else if (Array.isArray(data[key])) {
      data[key].forEach((item) => {
        OrganisationContractFormData.append(`${key}[]`, item);
      });
    } else {
      OrganisationContractFormData.append(key, data[key]);
    }
  }

  if (!id && !OrgId) {
    contractPictureFiles?.file.forEach((item) => {
      OrganisationContractFormData.append(
        "variation_agreement_documents[]",
        item,
        item.name
      );
    });
  }

  if (!id && !OrgId) {
    legalContractsFiles?.file.forEach((item) => {
      OrganisationContractFormData.append("legal_contracts[]", item, item.name);
    });
  }

  const OrganisationActivityFormData = new FormData();

  for (const key in OrganisationActivity.data) {
    const data = OrganisationActivity.data;

    if (Array.isArray(data[key])) {
      let tempArr = data && data[key].map((option) => option.value ?? option);

      if (tempArr.length === 0) {
        OrganisationActivityFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          OrganisationActivityFormData.append(`${key}[]`, option);
        });
      }
    } else {
      OrganisationActivityFormData.append(key, data[key]);
    }
  }

  if (!id && !OrgId) {
    activityPictureFiles?.file.forEach((item) => {
      OrganisationActivityFormData.append(
        "client_action_list[]",
        item,
        item.name
      );
    });
  }

  //-----------------------------------------------------------------------------
  // for section seventh
  //--------------------general  contract form data --------------------

  const OrganisationGeneralFormData = new FormData();

  for (const key in OrganisationGeneral.data) {
    const data = OrganisationGeneral.data;

    // if key of the object is an Array
    if (Array.isArray(data[key])) {
      let tempArr = data && data[key].map((option) => option.value ?? option);

      if (tempArr.length === 0) {
        OrganisationGeneralFormData.append(`${key}[]`, "");
      } else {
        tempArr.map((option) => {
          OrganisationGeneralFormData.append(`${key}[]`, option);
        });
      }
    } else {
      OrganisationGeneralFormData.append(key, data[key]);
    }
  }

  const OrganisationBusinessDevelopmentFormData = new FormData();

  for (const key in organisationBusinessDevelopment.data) {
    const data = organisationBusinessDevelopment.data;

    // if key of the object is an Array
    if (Array.isArray(data[key])) {
      data[key].forEach((item) => {
        OrganisationBusinessDevelopmentFormData.append(`${key}[]`, item);
      });
    } else {
      OrganisationBusinessDevelopmentFormData.append(key, data[key]);
    }
  }

  const [orgUpload, setOrgUpload] = React.useState([]);
  const [orgUpload1, setOrgUpload1] = React.useState([]);

  function getStepContent(step) {
    const profilePicture =
      fetchedFiles?.length &&
      fetchedFiles.find((item) => item.type === "profile_picture");
    switch (step) {
      case 0:
        return id ? (
          OrganisationDetail.data?.id && (
            <OrganisationDetails
              setSomeChangeDetected={setSomeChangeDetected}
              orgUpload1={orgUpload1}
              setOrgUpload1={setOrgUpload1}
              orgUpload={orgUpload}
              setOrgUpload={setOrgUpload}
              setImageBlob={setOrganizationImageBlob}
              existingImage={profilePicture}
            />
          )
        ) : (
          <OrganisationDetails
            setSomeChangeDetected={setSomeChangeDetected}
            orgUpload1={orgUpload1}
            setOrgUpload1={setOrgUpload1}
            orgUpload={orgUpload}
            setOrgUpload={setOrgUpload}
            setImageBlob={setOrganizationImageBlob}
            existingImage={profilePicture}
          />
        );
      case 1:
        return <Profile setSomeChangeDetected={setSomeChangeDetected} />;
      case 2:
        return (
          <Contact
            parentOrg={parentOrg}
            setSomeChangeDetected={setSomeChangeDetected}
          />
        );
      case 3:
        return (
          <OrganisationBusinessDevelopment
            setSomeChangeDetected={setSomeChangeDetected}
          />
        );
      case 4:
        return <PreContract setSomeChangeDetected={setSomeChangeDetected} />;
      case 5:
        return <Contract setSomeChangeDetected={setSomeChangeDetected} />;
      case 6:
        return <Activity setSomeChangeDetected={setSomeChangeDetected} />;
      case 7:
        return <General setSomeChangeDetected={setSomeChangeDetected} />;
      default:
        return "Not available";
    }
  }

  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const steps = getSteps();
  const [indexValue, setIndexValue] = React.useState(0);
  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleSubmit = (
    data,
    apiVariable,
    dispatchVariable,
    sectionId,
    headers,
    onlySave,
    proceedFurther
  ) => {
    if (sectionId !== null) {
      setLoading(true);
      DataService.updateData(data, sectionId, apiVariable, headers)
        .then((res) => {
          dispatch(dispatchVariable(res.data));
          setLoading(false);
          if (apiVariable === "organisation_details") {
            setMovable(res.movable);
          }
          console.log("apiVariable :>> ", apiVariable);
          dispatch(showSnackbar("success", ["Success!"]));
          if (!isAdmin) {
            if (activeStep === 2) {
              if (!onlySave) {
                proceedFurther
                  ? setActiveStep((prevActiveStep) => prevActiveStep + 1)
                  : setActiveStep(indexValue);
              } else {
                setSomeChangeDetected(false);
              }
            } else {
              if (!onlySave) {
                proceedFurther
                  ? setActiveStep((prevActiveStep) => prevActiveStep + 1)
                  : setActiveStep(indexValue);
              } else {
                setSomeChangeDetected(false);
              }
            }
          } else {
            if (!onlySave) {
              proceedFurther
                ? setActiveStep((prevActiveStep) => prevActiveStep + 1)
                : setActiveStep(indexValue);
            } else {
              setSomeChangeDetected(false);
            }
          }
          window.scroll({ top: 0 });

          if (activeStep === steps.length - 1) {
            !onlySave && dispatch(ResetOrganisationDetails());
          }
        })
        .catch((err) => {
          dispatch(showSnackbar("error", err.errors));
        });
    } else {
      setLoading(true);
      if (
        [
          "organisation_profile",
          "organisation_business_developments",
          "organisation_general",
          "organisation_pre_contract",
        ].includes(apiVariable)
      ) {
        data.append("organisation_id", OrgId);
      } else if (apiVariable === "organisation_details") {
        console.log("uploadFunction :>> ", UploadFunction.attributes);
        console.log("orgUpload321 :>> ", orgUpload);

        //cal a function to upload a file
      }
      DataService.createData(data, apiVariable, headers)
        .then((res) => {
          setLoading(false);
          console.log(
            "uploadFunction :>> ",
            UploadFunction.attributes,
            apiVariable
          );
          if (apiVariable === "organisation_details") {
            setMovable(res.movable);
          }
          dispatch(showSnackbar("success", ["Success!"]));
          if (dispatchVariable === UpdateOrganisationDetails) {
            console.log("then block");
            dispatch(UpdateOrganisationIdProfile(res.data));
            dispatch(UpdateOrganisationIdContact(res.data));
            dispatch(UpdateOrganisationIdPreContract(res.data));
            dispatch(UpdateOrganisationIdContract(res.data));
            dispatch(UpdateOrganisationIdGeneral(res.data));
            dispatch(UpdateOrganisationIdBusinessDev(res.data));
            dispatch(UpdateOrganisationIdActivity(res.data));
            dispatch(dispatchVariable(res.data));
          } else {
            dispatch(dispatchVariable(res.data));
          }

          if (!onlySave) {
            proceedFurther
              ? setActiveStep((prevActiveStep) => prevActiveStep + 1)
              : setActiveStep(indexValue);
          }
          window.scroll({ top: 0 });
        })
        .catch((err) => {
          dispatch(ResetOrganisationDetails());
          setLoading(false);
          dispatch(showSnackbar("error", err.errors));
        });
    }
  };

  // ----------------------------------------------------------------------------
  // handleNext does validation for mandatory fields and retuns errors to reducer
  // If no errors, then the function to make post/put call happens
  // ----------------------------------------------------------------------------
  const handleNext = (e) => {
    let onlySave = e?.target?.innerText.toLowerCase() === "Save".toLowerCase();
    let proceedFurther =
      e?.target?.innerText.toLowerCase() === "Save and proceed".toLowerCase();

    if (e?.target?.innerText.toLowerCase() === "Finish".toLowerCase()) {
      if (isAdmin) history.push(`/admin/organisation/list`);
      else history.push(`/OrganizationHome`);
    }
    if (activeStep === 0) {
      console.log("event");
      let valid = true;
      let errors = {
        organisation_name: false,
        individual_types: false,
        internal_status_id: false,
        territory_id: false,
        industry_sector_lists: false,
        date_source_received: false,
        source_referral1_id: false,
        source_referral2s: false,
        source_referral3_id: false,
      };
      if (
        !OrganisationDetail.data.organisation_name ||
        !OrganisationDetail.data.organisation_name.length
      ) {
        errors.organisation_name = true;
        valid = false;
      }
      if (
        !OrganisationDetail.data.individual_types ||
        !OrganisationDetail.data.individual_types.length
      ) {
        errors.individual_types = true;
        valid = false;
      }
      if (
        !OrganisationDetail.data.internal_status_id ||
        typeof OrganisationDetail.data.internal_status_id !== "number"
      ) {
        errors.internal_status_id = true;
        valid = false;
      }
      if (
        !OrganisationDetail.data.territory_id ||
        typeof OrganisationDetail.data.territory_id !== "number"
      ) {
        errors.territory_id = true;
        valid = false;
      }

      if (
        !OrganisationDetail.data.industry_sector_lists ||
        !OrganisationDetail.data.industry_sector_lists.length
      ) {
        errors.industry_sector_lists = true;
        valid = false;
      }

      if (!OrganisationDetail.data.source_referral1_id && isAdmin) {
        errors.source_referral1_id = true;
        valid = false;
      }

      if (
        !OrganisationDetail.data.source_referral2s &&
        !OrganisationDetail.data.source_referral2s?.length &&
        isAdmin
      ) {
        errors.source_referral2s = true;
        valid = false;
      }

      if (!OrganisationDetail.data.source_referral3_id && isAdmin) {
        errors.source_referral3_id = true;
        valid = false;
      }

      if (!OrganisationDetail.data.date_source_received) {
        errors.date_source_received = true;
        valid = false;
      }
      OrganisationDetailFormData.delete("meeting_details[]");
      OrganisationDetailFormData.set(
        "meeting_details",
        JSON.stringify(
          OrganisationDetail.data.meeting_details
            ? OrganisationDetail.data.meeting_details
            : []
        )
      );

      OrganisationDetailFormData.delete("client_action_lists[]");
      OrganisationDetailFormData.set(
        "client_action_lists",
        JSON.stringify(
          OrganisationDetail.data.client_action_lists
            ? OrganisationDetail.data.client_action_lists
            : []
        )
      );

      if (!valid) {
        dispatch(SetOrganisationDetailsError(errors));
        return;
      }
      authHeaders["content-type"] = "multipart/form-data";

      handleSubmit(
        OrganisationDetailFormData,
        "organisation_details",
        UpdateOrganisationDetails,
        OrganisationDetail.section_id,
        authHeaders,
        onlySave,
        proceedFurther
      );
      console.log("uploadFunction :>> ", UploadFunction());
    } else if (activeStep === 1) {
      let valid = true;
      let errors = {
        account_director: false,
        account_contact: false,
      };

      if (!valid) {
        dispatch(SetOrganisationProfileError(errors));
        return;
      }
      authHeaders["content-type"] = "multipart/form-data";
      handleSubmit(
        // OrganisationProfile.data,
        organisationProfileFormData,
        "organisation_profile",
        UpdateOrganisationProfile,
        OrganisationProfile.section_id,
        authHeaders,
        onlySave,
        proceedFurther
      );
    } else if (activeStep === 2) {
      let valid = true;
      let errors = {
        website: false,
        business_email: false,
        primary_email: false,
      };

      if (!OrganisationContact.data.website) {
        errors.website = true;
        valid = false;
      }
      if (OrganisationContact.data.primary_email !== "") {
        if (
          !new RegExp(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/).test(
            OrganisationContact.data.primary_email
          )
        ) {
          errors.primary_email = true;
          valid = false;
        }
      }
      if (
        OrganisationContact.data.organisation_branches[0]?.business_email !== ""
      ) {
        if (
          !new RegExp(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/).test(
            OrganisationContact.data.organisation_branches[0]?.business_email
          )
        ) {
          errors.business_email = true;
          valid = false;
        }
      }

      if (!valid) {
        dispatch(SetOrganisationContactError(errors));
        return;
      }
      const test = { ...OrganisationContact.data };
      console.log("test", test);
      const mtest2Key =
        test.departments && test["departments"].map((item) => item.id || item);
      const mtest2Key1 =
        test.business_units &&
        test["business_units"].map((item) => item.id || item);
      const mtest2Key2 =
        test.offices && test["offices"].map((item) => item.id || item);
      const mtest2Key3 =
        test.functions && test["functions"].map((item) => item.id || item);

      test["departments"] = mtest2Key;
      test["business_units"] = mtest2Key1;
      test["offices"] = mtest2Key2;
      test["functions"] = mtest2Key3;

      authHeaders["content-type"] = "application/json";
      handleSubmit(
        test,
        "organisation_contact",
        UpdateOrganisationContact,
        OrganisationContact.section_id,
        authHeaders,
        onlySave,
        proceedFurther
      );
    } else if (activeStep === 4) {
      authHeaders["content-type"] = "multipart/form-data";
      handleSubmit(
        OrganisationPreContractFormData,
        "organisation_pre_contract",
        UpdateOrganisationPreContract,
        OrganisationPreContract.section_id,
        authHeaders,
        onlySave,
        proceedFurther
      );
    } else if (activeStep === 5) {
      let valid = true;
      let errors = {
        start_date_with_client: false,
        date_account_closed: false,
      };
      if (!OrganisationContract.data.start_date_with_client) {
        errors.start_date_with_client = true;
        valid = false;
      }

      OrganisationContractFormData.delete("incomes[]");
      OrganisationContractFormData.set(
        "incomes",
        JSON.stringify(
          OrganisationContract.data.incomes
            ? OrganisationContract.data.incomes
            : []
        )
      );

      if (!valid) {
        dispatch(SetOrganisationContractError(errors));
        return;
      }
      authHeaders["content-type"] = "multipart/form-data";
      handleSubmit(
        OrganisationContractFormData,
        "organisation_contract",
        UpdateOrganisationContract,
        OrganisationContract.section_id,
        authHeaders,
        onlySave,
        proceedFurther
      );
    } else if (activeStep === 6) {
      let valid = true;
      let errors = {
        review_dates: false,
      };
      if (!OrganisationActivity.data?.review_dates?.length) {
        errors.review_dates = true;
        valid = false;
      }

      if (!valid) {
        dispatch(SetOrganisationActivityError(errors));
        return;
      }

      OrganisationActivityFormData.delete("meeting_details[]");
      OrganisationActivityFormData.set(
        "meeting_details",
        JSON.stringify(
          OrganisationActivity.data.meeting_details
            ? OrganisationActivity.data.meeting_details
            : []
        )
      );

      OrganisationActivityFormData.delete("client_action_lists[]");
      OrganisationActivityFormData.set(
        "client_action_lists",
        JSON.stringify(
          OrganisationActivity.data.client_action_lists
            ? OrganisationActivity.data.client_action_lists
            : []
        )
      );

      authHeaders["content-type"] = "multipart/form-data";
      handleSubmit(
        // OrganisationActivity.data,
        OrganisationActivityFormData,
        "organisation_activity",
        UpdateOrganisationActivity,
        OrganisationActivity.section_id,
        authHeaders,
        onlySave,
        proceedFurther
      );
    } else if (activeStep === 7) {
      authHeaders["content-type"] = "application/json";
      handleSubmit(
        // OrganisationGeneral.data,
        OrganisationGeneralFormData,
        "organisation_general",
        UpdateOrganisationGeneral,
        OrganisationGeneral.section_id
      );
    } else if (activeStep === 3) {
      let valid = true;
      let errors = {};

      OrganisationBusinessDevelopmentFormData.delete("meeting_details[]");
      OrganisationBusinessDevelopmentFormData.set(
        "meeting_details",
        JSON.stringify(
          organisationBusinessDevelopment.data.meeting_details
            ? organisationBusinessDevelopment.data.meeting_details
            : []
        )
      );
      OrganisationBusinessDevelopmentFormData.delete("task_lists[]");
      OrganisationBusinessDevelopmentFormData.set(
        "task_lists",
        JSON.stringify(
          organisationBusinessDevelopment.data.task_lists
            ? organisationBusinessDevelopment.data.task_lists
            : []
        )
      );

      if (!valid) {
        dispatch(SetOrganisationBusinessDevError(errors));
        return;
      }
      authHeaders["content-type"] = "application/json";
      handleSubmit(
        OrganisationBusinessDevelopmentFormData,
        "organisation_business_developments",
        UpdateOrganisationBusinessDev,
        organisationBusinessDevelopment.section_id,
        authHeaders,
        onlySave,
        proceedFurther
      );
    }
    setOpen(false);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleTabChange = (index) => {
    if (someChangeDetected) {
      setOpen(true);
    } else {
      setActiveStep(index);
    }
    setIndexValue(index);
    setSomeChangeDetected(false);
    // setActiveStep(index);
    window.scroll({ top: 0 });
  };
  console.log(indexValue);
  let loginRole = globaluserData?.role;
  // let loginRole = sessionStorage.getItem("role");
  console.log("someChange", someChangeDetected);
  return (
    <div className={classes.root}>
      {/* <Loader /> */}
      {loading && <Loader />}
      {/* <Snackbar/> */}
      <Stepper
        className={id ? classes.stepperContent : classes.stepperContentCreate}
        activeStep={activeStep}
        connector={false}
      >
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          return (
            <Step
              disabled={!isAdmin && [3, 7].includes(index)}
              onClick={() =>
                movable === true
                  ? !isAdmin && [3, 7].includes(index)
                    ? ""
                    : handleTabChange(index)
                  : ""
              }
              key={label}
              {...stepProps}
              style={{
                top: "240px",
                backgroundColor:
                  activeStep === index
                    ? "rgb(7, 127,131)"
                    : !isAdmin && [3, 7].includes(index)
                    ? "#cbcbcb"
                    : "",
                height: "30px",
                cursor:
                  movable === true
                    ? !isAdmin && [3, 7].includes(index)
                      ? "not-allowed"
                      : "pointer"
                    : "",
              }}
            >
              <StepLabel {...labelProps}>
                <Typography variant="h3">{label}</Typography>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <div>
        {activeStep === steps.length ? (
          // history.push(`/admin/organisation/list`)
          loginRole === "admin" ? (
            history.push(`/admin/organisation/list`)
          ) : (
            history.push("/OrganizationHome")
          )
        ) : (
          <div>
            <Typography variant="h2" className={classes.instructions}>
              {getStepContent(activeStep)}
            </Typography>
            <div className={classes.stepperButtons}>
              {activeStep !== 0 ? (
                <Button
                  disableElevation
                  variant="contained"
                  color="primary"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  className={classes.button}
                >
                  Back
                </Button>
              ) : (
                <span style={{ width: "20px" }}></span>
              )}
              <div
                style={{
                  display: "flex",
                  width: "20%",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  disableElevation
                  variant="contained"
                  color="secondary"
                  onClick={handleNext}
                  className={classes.button}
                  style={{ width: "25%" }}
                >
                  Save
                </Button>
                <Button
                  disableElevation
                  variant="contained"
                  color="secondary"
                  onClick={handleNext}
                  className={classes.button}
                >
                  {activeStep === steps.length - 1
                    ? "Finish"
                    : !isAdmin && activeStep === 6
                    ? "Finish"
                    : "Save and proceed"}
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div>
        <Dialog open={open} onClose={handleClose} indexValue={indexValue}>
          <DialogContent>
            <Grid container spacing={2} style={{ textAlign: "center" }}>
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  Do you want to save the changes ?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Button
                  disableElevation
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                  className={classes.button}
                  style={{ marginRight: "12px" }}
                >
                  Update
                </Button>
                <Button
                  disableElevation
                  variant="contained"
                  color="primary"
                  onClick={handleClose}
                  className={classes.button}
                  style={{ marginLeft: "12px" }}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
}
